import { z } from 'zod'

export const InternalTransferStatus = z.enum(['pending', 'approved', 'denied', 'expired'])
export type InternalTransferStatus = z.infer<typeof InternalTransferStatus>

export const InternalTransferRequest = z.object({
  id: z.number(),
  domain_name: z.string(),
  domain_id: z.number().nullable().optional(),
  status: InternalTransferStatus,
  created_at: z.number(),
  expires_at: z.number(),
  responded_at: z.number().nullable().optional(),
  buyer_email: z.string().nullable().optional()
})
export type InternalTransferRequest = z.infer<typeof InternalTransferRequest>

export const InternalTransferListResponse = z.object({
  requests: z.array(InternalTransferRequest),
  total_count: z.number(),
  limit: z.number(),
  offset: z.number()
})
export type InternalTransferListResponse = z.infer<typeof InternalTransferListResponse>

export const InternalTransferCountResponse = z.object({
  count: z.number()
})
export type InternalTransferCountResponse = z.infer<typeof InternalTransferCountResponse>

export const InternalTransferApproveRequest = z.object({
  otp: z.string().optional()
})
export type InternalTransferApproveRequest = z.infer<typeof InternalTransferApproveRequest>

export const InternalTransferOtpRequiredError = z.object({
  error: z.enum(['totp_required', 'otp_required'])
})
export type InternalTransferOtpRequiredError = z.infer<typeof InternalTransferOtpRequiredError>
